export default "__VITE_PUBLIC_ASSET__687246f5__"